import type { ReactNode } from 'react';
import styles from './Newsreel.module.css';

/**
 * A black-and-white newsreel frame around its children: grain, scratches, a projector's flicker
 * and the holes of the film. `title` is the card at the top. With "reduce motion" the picture
 * is the same, held still.
 */
export function Newsreel({
  title,
  children,
  className,
}: {
  title: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={[styles['reel'], className ?? ''].join(' ')}>
      <span className={[styles['holes'], styles['left']].join(' ')} aria-hidden="true" />
      <span className={[styles['holes'], styles['right']].join(' ')} aria-hidden="true" />
      <span className={styles['grain']} aria-hidden="true" />
      <span className={styles['scratch']} aria-hidden="true" />
      <span className={styles['scratchB']} aria-hidden="true" />
      <div className={styles['body']}>
        <p className={styles['title']}>{title}</p>
        {children}
      </div>
    </section>
  );
}
